<template>
	<!-- 日期插件 -->
	<div class="rqbox" :style="{'background':bgColor}">
		<div class="title">
			<span class="titlename">{{title}}</span>
			<span class="titletips">
				<van-icon name="info-o" />{{titlermark}}
			</span>
		</div>
		<div class="rqlist">
			<div class="riitem" v-for="(item,index) in dateList" :key="index" @click="checkDate(item)"
				:class="checkdate==item?'riitem-active':''">
				<div class="itemname">
					<span>{{item.dd.week}}</span>
					<span>{{item.dd.dd}}</span>
				</div>
				<div class="price">
					￥<span>{{item.price}}</span>
				</div>
				<div class="stockdiv">
					余:{{item.stock}}
				</div>
			</div>
			<div class="riitem riitems" @click="show=true">
				<div class="itemname">
					<div>更多日期

					</div>
					<div>
						<van-icon name="arrow" />
					</div>
				</div>
				<!-- <div class="tips-top">
					￥{{sprice}}起
				</div> -->
			</div>
		</div>
		<van-calendar v-model="show" color="#ffaa00" type="single" style="margin-bottom: 0;" :style="{ height: '65%' }"
			:default-date="selectDate" :formatter="formatter" :show-confirm="false" @confirm="onConfirm">
			<template #top-info="item">
				<span style="color: #ff0000;">{{item.topInfo}}</span>
			</template>
		</van-calendar>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		name: 'leoCalendar',
		props: {
			title: {
				type: String,
				default: '选择日期'
			},
			titlermark: {
				type: String,
				default: '请选择使用日期'
			},
			bgColor: {
				type: String,
				default: "#fff8f9"
			},
			deData: {
				type: Object,
				default: {
					defaultPrice: 0,
					defaultStock: 0,
					Dates: []
				}
			},
			useDate: {
				type: String
			}
		},
		data() {
			return {
				show: false,
				prices: [],
				dateList: [],
				checkdate: '',
				sprice: '99',
				deDataList: this.deData,
				selectDate: null
			}
		},
		methods: {
			// 选中日期
			checkDate(item) {
				this.checkdate = item
				let dd = new Date(item.dd.date)
				this.selectDate = dd
				// 子组件中触发父组件方法并传值
				this.$emit('confirm', item)
			},
			onConfirm(date) {
				let that = this
				let dqdate = that.formatDate(date);
				const yy = date.getFullYear();
				const month = date.getMonth() + 1;
				const day = date.getDate();
				const zdate = yy + '-' + String(month < 10 ? '0' + month : month) + '-' + String(day < 10 ? '0' + day :
					day);
				let dd = that.deDataList.Dates;
				const [
					price,
					stock
				] = that.getDatePrice(zdate);
				let item = {
					price: price,
					stock: stock,
					dd: that.getWeek(dqdate)
				};
				//选择的时候是  存在 列表显示的 start
				let checkitem = ''
				for (var i = 0; i < that.dateList.length; i++) {
					if (item.dd.date == that.dateList[i].dd.date) {
						checkitem = that.dateList[i]
						break;
					}
				}
				if (checkitem == '') {
					that.checkdate = item
					that.dateList.splice(2, 1, item);
				} else {
					that.checkdate = checkitem
				}
				this.$emit('confirm', that.checkdate)
				//选择的时候是  存在 列表显示的 end
				that.show = false
			},
			// 获取星期
			getWeek(date) {
				let myDate = new Date(date);
				let newDate = new Date();
				let newyy = String(newDate.getFullYear());
				let newmm = newDate.getMonth() + 1;
				let newdd = String(newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate());
				let yy = String(myDate.getFullYear());
				let wk = myDate.getDay();
				let mm = myDate.getMonth() + 1;
				let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate());
				let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
				let tday = '';
				if (newyy == yy && newmm == mm) {
					if (newDate.getDate() - myDate.getDate() == 0) {
						tday = '今天'
					} else if (newDate.getDate() - myDate.getDate() == -1) {
						tday = '明天'
					}
				}
				let mmm = String(mm < 10 ? '0' + mm : mm);
				return {
					date: yy + '-' + mmm + '-' + dd,
					dd: mmm + '-' + dd,
					week: tday == '' ? weeks[wk] : tday
				};
			},
			getListDate(date) {
				let that = this;
				that.dateList = []
				let ddlist = []
				let ddate = that.GetDateStr(that.useDate, 0); //今天
				let ddate2 = that.GetDateStr(that.useDate, 1); //明天
				ddlist.push({
					price: that.getDatePrice(ddate)[0],
					stock: that.getDatePrice(ddate)[1],
					dd: that.getWeek(ddate)
				})
				ddlist.push({
					price: that.getDatePrice(ddate2)[0],
					stock: that.getDatePrice(ddate2)[1],
					dd: that.getWeek(ddate2)
				})
				if (date == null) {
					let ddate3 = that.GetDateStr(that.useDate, 2) //后天 
					ddlist.push({
						price: that.getDatePrice(ddate3)[0],
						stock: that.getDatePrice(ddate3)[1],
						dd: that.getWeek(ddate3)
					})
				} else {
					ddlist.push({
						price: that.getDatePrice(date)[0],
						stock: that.getDatePrice(date)[1],
						dd: that.getWeek(date)
					})
				}
				that.dateList = ddlist;
			},
			GetDateStr(sdate, AddDayCount) {
				var dd = new Date();
				if (sdate != '') {
					dd = new Date(sdate);
				}
				dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1; //获取当前月份的日期
				var d = dd.getDate();
				m = String(m < 10 ? '0' + m : m);
				d = String(d < 10 ? '0' + d : d);
				return y + "-" + m + "-" + d;
			},
			getDatePrice(d) {
				let that = this;
				let dds = that.deDataList.Dates;
				if (dds.length == 0) {
					return [
						that.deDataList.defaultPrice,
						that.deDataList.defaultStock
					]
				}
				for (let i = 0; i < dds.length; i++) {
					if (dds[i].date == d) {
						return [
							dds[i].goods_price,
							dds[i].stock > 0 ? dds[i].stock : -1
						];
					}
				}
				return [
					-1,
					-1
				];
			},
			formatDate(date) {
				return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
			},
			formatter(day) {
				let that = this
				const yy = day.date.getFullYear();
				const month = day.date.getMonth() + 1;
				const date = (day.date.getDate());
				const zdate = yy + '-' + String(month < 10 ? '0' + month : month) + '-' + String(date < 10 ? '0' + date :
					date);
				var ps = that.getDatePrice(zdate);
				var price = ps[0];
				var stock = ps[1];
				if (price != -1) {
					day.topInfo = `￥${price}`;
				}
				if (stock != -1) {
					day.bottomInfo = `余:${stock}`;
				}
				let nn = that.GetDateStr(that.useDate, -1)
				if (that.compare(nn, day.date) || price == -1 || stock == -1) {
					day.type = 'disabled'
				}
				return day;
			},
			compare(d1, d2) {
				let ds1 = new Date(d1);
				let ds2 = new Date(d2);
				if (ds2 > ds1) {
					return false
				} else {
					return true
				}
			},

			//初始化日历
			initDate() {
				let that = this
				let ddlist = []
				var dd;
				let ii = 3;
				if (that.deDataList.Dates.length < 1) {
					//没有设置日历价格，就每天都可以选择
					let ddate = that.GetDateStr(that.useDate, 0); //今天
					let ddate2 = that.GetDateStr(that.useDate, 1); //明天
					ddlist.push({
						price: that.getDatePrice(ddate)[0],
						stock: that.getDatePrice(ddate)[1],
						dd: that.getWeek(ddate)
					})
					ddlist.push({
						price: that.getDatePrice(ddate2)[0],
						stock: that.getDatePrice(ddate2)[1],
						dd: that.getWeek(ddate2)
					})
					let ddate3 = that.GetDateStr(that.useDate, 2) //后天 
					ddlist.push({
						price: that.getDatePrice(ddate3)[0],
						stock: that.getDatePrice(ddate3)[1],
						dd: that.getWeek(ddate3)
					})
				} else {
					var len = that.deDataList.Dates.length > 3 ? 3 : that.deDataList.Dates.length
					//设置了 就只能选择设置了的
					for (var i = 0; i < len; i++) {
						let obj = that.deDataList.Dates[i];
						ddlist.push({
							price: obj.goods_price,
							stock: obj.stock,
							dd: that.getWeek(obj.date)
						})
					}
				}
				that.dateList = ddlist
			}
		},
		mounted() {
			Toast.loading({
				message: '请稍后...',
				loadingType: 'spinner',
				forbidClick: true,
				duration: 0, //展示时长(ms)，值为 0 时，toast 不会消失
				className: 'leoloading'
			});
			setTimeout(() => {
				this.initDate();
				// this.getListDate(null)
				this.checkDate(this.dateList[0]); //默认选中第一天
				Toast.clear()
			}, 300);
		}
	}
</script>

<style lang="less" scoped>

</style>